import { itamSettingsRoute } from '@jira/router-routes__itam-routes/src/itamSettingsRoute.tsx';
import { itamSettingsEntryPoint } from '@jira/spa-apps__itam-settings/src/itamSettingsEntryPoint.entrypoint.tsx';
import { MenuIdItam } from '@jira/navigation-apps__constants/src/MenuIdItam.tsx';
import { SidebarIdItamSettings } from '@jira/navigation-apps__constants/src/SidebarIdItamSettings.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { verticalInstantiationResource } from '@jira/router-resources__itam/src/verticalInstantiationResource.tsx';
import { avsWorkspaceResource } from '@jira/router-resources__itam/src/avsWorkspaceResource.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { workspaceResource } from '@jira/servicedesk__insight-common-services-workspace-context/src/workspaceResource.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { rightSidebarsLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const itamSettingsPageEntryPoint = createPageEntryPoint({
	main: itamSettingsEntryPoint,
});

export const itamSettingsRouteEntry: Route = createEntry(itamSettingsRoute, () => ({
	group: 'servicedesk',
	layout: rightSidebarsLayout,
	navigation: {
		menuId: MenuIdItam,
		sidebarId: SidebarIdItamSettings,
	},
	resources: [
		...getNavigationResources(),
		workspaceResource,
		verticalInstantiationResource,
		resourceWithCondition(() => fg('itam_ftw'), avsWorkspaceResource),
	],
	entryPoint() {
		return fg('itam_ftw') ? itamSettingsPageEntryPoint : notFoundPageEntrypoint;
	},
	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
